/**
 * 促销规则域枚举常量定义
 */

// 替代品规则状态
export enum SubstituteRuleStatus {
  ENABLED = 'ENABLED',       // 启用
  DISABLED = 'DISABLED',     // 禁用
}

export const SubstituteRuleStatusOptions = [
  { value: SubstituteRuleStatus.ENABLED, label: 'promotionRule.ruleStatus.enabled', color: 'green' },
  { value: SubstituteRuleStatus.DISABLED, label: 'promotionRule.ruleStatus.disabled', color: 'default' },
];

// 替代品规则类型
export enum SubstituteRuleType {
  SAME_CATEGORY = 'SAME_CATEGORY',       // 同类替换
  CROSS_CATEGORY = 'CROSS_CATEGORY',     // 跨类替换
  CUSTOM = 'CUSTOM',                     // 自定义替换
}

export const SubstituteRuleTypeOptions = [
  { value: SubstituteRuleType.SAME_CATEGORY, label: 'promotionRule.ruleType.sameCategory' },
  { value: SubstituteRuleType.CROSS_CATEGORY, label: 'promotionRule.ruleType.crossCategory' },
  { value: SubstituteRuleType.CUSTOM, label: 'promotionRule.ruleType.custom' },
];
